import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import FadeIn from "@/components/FadeIn";

export default function Destinations() {
  const [destinations, setDestinations] = useState(null);
  const [tab, setTab] = useState("India");
  useEffect(() => { api.get("/destinations").then((r) => setDestinations(r.data)).catch(() => setDestinations([])); }, []);

  const filtered = destinations ? destinations.filter((d) => (d.region || "International") === tab).sort((a, b) => a.name.localeCompare(b.name)) : null;

  return (
    <>
      <SEO title="Destinations | Happy Holidays Wale" description="Explore our handpicked India & International holiday destinations." />
      <div className="bg-navy py-14" style={{ backgroundColor: "#002244" }}>
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Explore Destinations</h1>
          <p className="mt-3 max-w-xl text-white/70">Handpicked places waiting to be discovered. Find your next adventure.</p>
          <div className="mt-6 flex gap-2">
            {["India", "International"].map((t) => (
              <button key={t} data-testid={`dest-tab-${t}`} onClick={() => setTab(t)} className={`rounded-full px-6 py-2.5 text-sm font-bold transition-colors ${tab === t ? "brand-gradient text-white" : "bg-white/10 text-white hover:bg-white/20"}`}>{t}</button>
            ))}
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(filtered || Array.from({ length: 6 })).map((d, i) =>
            d ? (
              <FadeIn key={d.id} delay={i * 0.03}>
                <Link to={`/destination/${d.slug}`} data-testid={`destination-card-${d.slug}`} className="group relative block overflow-hidden rounded-3xl card-soft hover-lift">
                  <div className="aspect-[4/3] overflow-hidden"><img src={d.image} alt={d.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" /></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 flex w-full items-end justify-between p-6">
                    <div><h3 className="font-display text-2xl font-bold text-white">{d.name}</h3><p className="text-sm text-white/70">{d.country}</p></div>
                    <span className="flex h-10 w-10 items-center justify-center rounded-full brand-gradient text-white transition-transform group-hover:translate-x-1"><ArrowRight className="h-5 w-5" /></span>
                  </div>
                </Link>
              </FadeIn>
            ) : <div key={i} className="aspect-[4/3] skeleton rounded-3xl" />
          )}
        </div>
      </div>
    </>
  );
}
